module.exports = __webpack_public_path__ + "static/media/halona-logotype-l.e8b1f084.svg";